<nav aria-label="breadcrumb" class="pt-2 sticky-top top-65 z-index-0">
  <ol class="breadcrumb">
    <ng-container *ngFor="let item of breadcrumb; last as isLast">
      <li class="breadcrumb-item">
        <span *ngIf="!isLast; else elseBlock">
          <a [routerLink]="item.path">
            {{item.name}}
          </a>
        </span>
      </li>
      <ng-template #elseBlock>
        {{item.name}}
      </ng-template>
    </ng-container>
  </ol>
</nav>
